<div class="pdf-viewer-container" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <div class="pdf-viewer-header">
        <div class="d-flex align-items-center header-content">
            <mat-icon [svgIcon]="'document-pdf'" alt="PDF" class="pdf-icon"></mat-icon>
            <p class="d-flex align-items-center file-name disclaimer-bold psic-mt-1">{{ data.fileName }}</p>
        </div>
        <mat-icon [svgIcon]="'close-alt'" (click)="onClose()" class="close-icon"></mat-icon>
    </div>

    <div class="psic-py-4">
        <h5 class="doc-summary">Doc Summary</h5>
    </div>

    <div class="pdf-viewer-content psic-px-4">
        <iframe [src]="sanitizedUrl" frameborder="0" allow="local-network-access"></iframe>
    </div>

    @if (data.commType !== 'in') {
    <div class="d-flex justify-content-end align-items-center gap-2 psic-pt-4">
        <lib-button class="send-via-sms" buttonText="Send via SMS" buttonType="borderless" [buttonTheme]="'secondary'"
         (click)="sendDocumentBySMS()"></lib-button>
        <lib-button buttonText="Send by email" (click)="sendDocumentByEmail()"></lib-button>
    </div>
    }
</div>